<template>
    <div class="page">
        <Headers></Headers>
        <div class="banner">
            <!-- 顶部标题 -->
            <div class="pdfPageTitle mg_t">
                <div class="pdfPageTitle-txt">
                    <span class="pdfPageTitle-txt__first">运营排放</span>
                    <span class="pdfPageTitle-txt__second">(权重{{PdftStore.fromData.spaceEmissionOperational?.weight}}%)</span>
                </div>
                <!-- <div class="pdfPageTitle-icon">
                    <img src="@/assets/img/page5.png">
                </div> -->
            </div>

            <!-- 顶部数据 -->
            <div class="top_box">
                <div class="left">
                    <div class="title mg_b">排放数据：</div>
                    <div class="txt">范围一：<span class="mg_l">{{PdftStore.fromData.spaceEmissionOperational?.scope1Str}}</span></div>
                    <div class="txt" style="margin-top: 10px;">范围二：<span class="mg_l">{{PdftStore.fromData.spaceEmissionOperational?.scope2Str}}</span></div>
                </div>
                <div class="right">
                    <div class="title">数据与参考标准</div>
                    <div class="txt">{{PdftStore.fromData.spaceEmissionOperational?.referenceStandards}}</div>
                </div>
            </div>

            <!-- 明细 -->
            <div class="min_box">
                <div class="title">碳中和进程评级得分明细</div>
                <List :type=1 :id="'listPdfReport1'"/>
            </div>

            <!-- 数据图表 -->
            <div class="banner_box">
                <div class="left_box">
                    <div class="top_box_banner">
                        <div class="title">运营排放得分：</div>
                        <div class="jindu" v-if="PdftStore.fromData.spaceEmissionOperational">
                            <NewPro
                            :name="'page5progess'"
                            :centerNum="1"
                            :minScore="0"
                            :centerScore="70"
                            :leftScore="PdftStore.fromData.spaceEmissionOperational?.emissionScore"
                            :maxEmiss="'高排放'"
                            :minEmiss="'低排放'"
                            :maxScore="100"
                            :rightMinScore="0"
                            :rightMaxScore="30"
                            :rightScore="PdftStore.fromData.spaceEmissionOperational?.certificationScore"
                            :rightMinTxt="'无认证'"
                            :rightMaxTxt="'高质量认证'"
                            />
                        </div>
                    </div>
                    <div class="title">在参评企业中的位置</div>
                    <div class="ec_t" v-if="PdftStore.fromData.spaceEmissionOperational">
                        <Elist
                            :name="'elist1'"
                            :lineNum="[
                                {
                                    txt:'0-10,000吨',
                                    min:0,
                                    max:10000,
                                },
                                {
                                    txt:'10,001-50,000吨',
                                    min:10001,
                                    max:50000,
                                },
                                {
                                    txt:'50,001-100,000吨',
                                    min:50001,
                                    max:100000,
                                },
                                {
                                    txt:'100,001-500,000吨',
                                    min:100001,
                                    max:500000,
                                },
                                {
                                    txt:'500,001-1,000,000吨',
                                    min:500001,
                                    max:1000000,
                                },
                                {
                                    txt:'1,000,001-4,000,000吨',
                                    min:1000001,
                                    max:4000000,
                                },
                                {
                                    txt:'>4,000,000吨',
                                    min:4000001,
                                    max:null,
                                },
                            ]"
                            :lineHeight="'10px'"
                            :lineRadius="'10px'"
                            :imgId="PdftStore.fromData.orgInfo?.logoId"
                            :num="PdftStore.fromData.spaceEmissionOperational.emissionData"
                        />
                    </div>
                </div>
                <div class="right_box">
                    <div class="top_box_banner">
                        <div class="title">评分逻辑</div>
                        <div class="txt">{{PdftStore.fromData.spaceEmissionOperational?.scoreStandard}}</div>
                    </div>
                    <div class="title">碳中和评级进程综合表现</div>
                    <div class="ec_t" v-if="PdftStore.fromData.spaceEmissionOperational">
                        <Echarts :name="'page5echarts'" :type="'a'"/>
                    </div>
                </div>
            </div>
            <!-- 底部 -->
            <Bottoms/>
            <div class="flxed">03</div>
        </div>
    </div>
</template>

<script>
import { reactive, toRefs, onBeforeMount, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router';
import Headers from '../components/headers.vue'
import Bottoms from '../components/bottoms.vue'
import List from '../components/list.vue'
import NewPro from '../components/newPro.vue'
import Elist from '../components/eList.vue'
import Echarts from '../components/echarts.vue'
import { usePdftStore } from '@/store/pdf'
import { formatDateTimeYYmm, formatDateTimeYY } from '@/utils/date'
export default {
    name: 'page5',
    components:{Headers, Bottoms, List, Elist, NewPro, Echarts},
    setup() {
        const data = reactive({
            xdata:{
                name:'万吨',
                data:['0-10','11-50','51-100','101-200','201-300','301-400','>401']
            },
            ydata:{
                name:'',
                type:1
            },
            series:{
                data:[
                    {
                        value:60,
                        type:1,
                        name:'隆基股份隆基股份'
                    }, 
                    16, 
                    28, 
                    25, 
                    8, 
                    3, 
                    2
                ],
            },
        })
        //引入数据管理库
        const PdftStore = usePdftStore()
        const formatDateTimeYYmms = (str) => {
            return formatDateTimeYYmm(str)
        }
        const formatDateTimeYYs = (str) => {
            return formatDateTimeYY(str)
        }
        onBeforeMount(() => {})
        onMounted(() => {})
        return {
            PdftStore,
            formatDateTimeYYmms,
            formatDateTimeYYs,
            ...toRefs(data),
        }
    },
}

</script>
<style scoped lang='less'>
.page{
    width: 1512px;
    height: 2149px;
    margin: 0 auto;
    background: #FFFFFF;
    position: relative;
    .banner{
        width: 100%;
        padding: 0 130px;
        .mg_t{
            margin-top: 96px;
        }
        .flxed{
            position: absolute;
            right: 20px;
            bottom: 20px;
            font-size: 24px;
            font-weight: 400;
            color: #333333;
            line-height: 33px;
        }
        .top_box{
            margin-top: 50px;
            display: flex;
            justify-content: stretch;
            .title{
                font-size: 28px;
                font-weight: bold;
                color: #333333;
                line-height: 42px;
            }
            .left{
                width: 670px;
                padding-right: 40px;
                border-right: 1px dashed #C5C5C6;
                flex: 1;
                .mg_b{
                    margin-bottom: 20px;
                }
                .txt{
                    font-size: 28px;
                    font-weight: 500;
                    color: #333333;
                    line-height: 36px;
                    white-space: normal;
                    word-wrap: break-word;
                    .mg_l{
                        color: rgba(0, 186, 244, 1);
                    }
                }
                .tx{
                    margin-top: 15px;
                    font-size: 18px;
                    font-weight: 400;
                    color: #666666;
                }
            }
            .right{
                width: calc(100% - 670px);
                padding-left: 40px;
                flex: 1;
                .txt{
                    font-size: 16px;
                    font-weight: 400;
                    color: #333333;
                    line-height: 24px;
                    margin-top: 23px;
                    white-space: normal;
                    word-wrap: break-word;
                }
            }
            
        }
        .min_box{
            margin-top: 55px;
            font-size: 24px;
            font-weight: 500;
            color: #333333;
            line-height: 42px;
            .title{
                margin-bottom: 33px;
                font-weight: bold;
            }
        }
    }
}
.banner_box{
    display: flex;
    width: 100%;
    height: 900px;
    margin-top: 30px;
    justify-content: stretch;
    .left_box{
        width: 670px;
        padding-right: 40px;
        border-right: 1px dashed #C5C5C6;
        flex: 1;
    }
    .right_box{
        width: calc(100% - 670px);
        flex: 1;
        padding-left: 40px;
    }
    .top_box_banner{
        height: 350px;
    }
    .title{
        font-size: 28px;
        font-weight: bold;
        color: #333333;
        line-height: 42px;
    }
    .jindu{
        height: calc(350px - 42px);
        width: 100%;
        display: flex;
        align-items: center;
    }
    .mg_top{
        margin-top: 90px;
    }
    .ec_t{
        margin-top: 10px;
        width: 100%;
        height: 413px;
    }
    .txt{
        font-size: 16px;
        font-weight: 400;
        color: #333333;
        line-height: 24px;
        text-align: justify;
        margin-top: 10px;
        white-space: normal;
        word-wrap: break-word;
    }
    .txt_s{
        color: #999999;
    }
}
</style>